import './LoadingIndicator.css';

const LoadingIndicator = ({ animate }: { animate: boolean }) => {
  return (
    <div
      data-animate={animate}
      data-testid='loading-indicator'
      className={`size-6 bg-gx-highlight ${animate ? 'animate-ai-chat-pulse' : ''}`}
    />
  );
};

export default LoadingIndicator;
